// src/app/core/services/signature-size.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { HttpClientBase } from './http-client-base.service';

@Injectable({ providedIn: 'root' })
export class SignatureSizeService extends HttpClientBase {
  constructor(http: HttpClient) {
    super(http, 'signature-size'); // o '/signature-size'
  }

  /** GET /signature-size */
  getAll(trackLoading = true): Observable<any[]> {
    return this.get<any[]>({ trackLoading }).pipe(
      map((resp) => resp.body ?? []),
    );
  }

  /** GET /signature-size/:id */
  getById(id: number, trackLoading = true): Observable<any> {
    return this.show<any>(id, undefined, undefined, trackLoading);
  }

  /** POST /signature-size */
  create(dto: any, trackLoading = true): Observable<any> {
    return this.post<any>(dto, undefined, undefined, trackLoading);
  }

  /** PATCH /signature-size/:id */
  update(id: number, dto: any, trackLoading = true): Observable<any> {
    return this.patch<any>(dto, String(id), undefined, trackLoading);
  }

  /** DELETE /signature-size/:id */
  remove(id: number, trackLoading = true): Observable<any> {
    return this.delete<any>(String(id), undefined, undefined, trackLoading);
  }
}